import React from 'react'
import classNames from 'classnames'

type DividerProps = {
  className?: string
  inverted?: boolean
}

export const Divider: React.FC<DividerProps> = ({ className: classNameFromProps, inverted }) => {
  return (
    <hr
      className={classNames(classNameFromProps, 'border-[#EDEFF5] w-full', {
        'opacity-10': inverted,
      })}
    />
  )
}
